
// State Object for ArtistsCatalog. Dont directly mutate it anywhere except the artists/mutations.js file
export const statementState = {
  statementList: null,
  statementPaymentData:null,
  statementDetails:null

}


